import { TranslationDictionary } from '@plandi/common'

export const PROFILES_KEY = 'profiles'

export const PROFILE_REVIEWS_KEY = 'profileReviews'

export enum PROFILE_TYPE {
  COMPANY = 'profileCompany',
  SPECIALIST = 'profileSpecialist'
}

export const COMPANIES = 'companies'

export enum REVIEW_TYPE {
  BAD = 'BAD',
  GOOD = 'GOOD',
  NEUTRAL = 'NEUTRAL'
}

//export const REVIEW_TYPE_VALUES = {
export const getReviewTypeValues = (
  translate?: TranslationDictionary['data']
) => {
  return {
    [REVIEW_TYPE.GOOD]: translate?.REVIEW_TYPE_VALUES.GOOD,
    [REVIEW_TYPE.NEUTRAL]: translate?.REVIEW_TYPE_VALUES.NEUTRAL,
    [REVIEW_TYPE.BAD]: translate?.REVIEW_TYPE_VALUES.BAD
  }
}
